import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { Avatar, AVATAR_HEIGHT_20 } from '../../../Avatar'
import { FloatingTooltip } from '../../../Floating'
import { getListingPortalLabel } from '../../../RentalPortalListing'
import { TableCellBase, TableEmptyCell } from '../../../Table'
import { getPortalAvatarProps } from '../../RentalPortal.utils'

import * as styles from './RentalPortalListingsPortalsCell.module.css'

function RentalPortalListingsPortalsCell({ summary, ...cellProps }) {
  return summary?.length > 0 ? (
    <TableCellBase
      {...cellProps}
      className={styles.RentalPortalListingsPortalsCell}
    >
      {summary.map(publication => (
        <FloatingTooltip
          content={getListingPortalLabel(publication.portal)}
          key={publication.id}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Avatar
            {...getPortalAvatarProps(publication.portal)}
            className={styles.logo}
            size={AVATAR_HEIGHT_20}
          />
        </FloatingTooltip>
      ))}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default RentalPortalListingsPortalsCell
